module.exports = __webpack_public_path__ + "img/edu.71af1c16.png";